module.exports = __webpack_public_path__ + "static/images/user_photo_male.de67a37.png";


//////////////////
// WEBPACK FOOTER
// ./src/commons/style/images/user_photo_male.png
// module id = nRaH
// module chunks = 51